import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { isCaseworker } from '@debbie/common/dist/permissions/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { selectAllUsers } from '@debbie/cortex/dist/users/selectors.js';
import THEME from '../theme.js';
import SearchInput from './SearchInput.js';
import { RadioSelect, UserPreview } from './index.js';
import { useTeams } from '@debbie/cortex/dist/teams/index.js';
const SearchResponsible = (props) => {
    const allUsers = useSelector(selectAllUsers);
    const teamsLoadable = useTeams();
    const teams = h.hasData(teamsLoadable) ? teamsLoadable.data : null;
    const lang = useSelector((s) => s.lang);
    const [type, setType] = useState(props.responsible?.type || 'user');
    useEffect(() => {
        if (!allUsers) {
            c.users.getAll();
        }
    }, []);
    const selectedUser = props.responsible &&
        allUsers &&
        allUsers.find((user) => user.id === props.responsible?.referenceId);
    const selectedTeam = props.responsible &&
        teams &&
        teams.find((teams) => teams.id === props.responsible?.referenceId);
    const searchAllUsers = (q) => (allUsers || [])
        .filter((user) => (!q ||
        (user.firstName || '').toLowerCase().indexOf(q.toLowerCase()) !==
            -1 ||
        (user.lastName || '').toLowerCase().indexOf(q.toLowerCase()) !==
            -1) &&
        isCaseworker(user.role))
        .slice(0, 10)
        .map((user) => ({
        heading: (React.createElement("div", null,
            React.createElement(UserPreview, { user: user }),
            user.firstName,
            " ",
            user.lastName)),
        subheading: (React.createElement("div", { style: { marginLeft: '33px', marginTop: '-7px' } }, user.role)),
        returnData: user.id,
        key: user.id,
    }));
    const searchTeams = (q) => (teams || [])
        .filter((team) => !q || (team.name || '').toLowerCase().indexOf(q.toLowerCase()) !== -1)
        .slice(0, 10)
        .map((team) => ({
        heading: team.name,
        returnData: team.id,
        key: team.id,
    }));
    return (React.createElement("div", null,
        React.createElement("div", { style: { marginBottom: '10px' } },
            React.createElement(RadioSelect, { active: type === 'user', label: lang.teams.user, onClick: () => setType('user') }),
            React.createElement(RadioSelect, { active: type === 'team', label: lang.teams.team, onClick: () => setType('team') })),
        type === 'user' && (React.createElement("div", { style: { marginBottom: `-${THEME.GRID_SPACING}px` } },
            React.createElement(SearchInput, { onSelect: async (userId) => {
                    props.onChange({
                        type: 'user',
                        referenceId: userId,
                    });
                }, searchDelay: 0, forceOpen: true, placeholder: lang.teams.selectUser, searchAll: searchAllUsers, static: selectedUser &&
                    `${selectedUser.firstName} ${selectedUser.lastName}`, onRemoveStatic: () => props.onChange(null) }))),
        type === 'team' && (React.createElement("div", { style: { marginBottom: `-${THEME.GRID_SPACING}px` } },
            React.createElement(SearchInput, { onSelect: async (teamId) => {
                    props.onChange({
                        type: 'team',
                        referenceId: teamId,
                    });
                }, searchDelay: 0, forceOpen: true, placeholder: lang.teams.selectTeam, searchAll: searchTeams, onRemoveStatic: () => props.onChange(null), static: selectedTeam && selectedTeam.name })))));
};
export default SearchResponsible;
//# sourceMappingURL=SearchResponsible.js.map